/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type KiteTokenTransferListRequest = {
    tokenType?: KiteTokenTransferListRequest.tokenType;
    page?: number;
    size?: number;
};

export namespace KiteTokenTransferListRequest {

    export enum tokenType {
        NA = 'NA',
        CA = 'CA',
        ERC20 = 'ERC20',
        ERC721 = 'ERC721',
        ERC1155 = 'ERC1155',
    }


}

